import { useInfiniteQuery } from '@tanstack/react-query';

import { get } from '@truefit/http-utils';
import { SessionData } from '@/types/user';

export interface SessionsPageResponse {
  data: SessionData[];
  hasNextPage: boolean;
  nextCursor: string | null;
}

export function getQueryKey(orgId:number) {
  return ['AllUsers', orgId];
}
const LIMIT = 5;
const fetchUserSessions = async ({ pageParam = null }: { pageParam?: string | null }) => {
  const urlSearchParams = new URLSearchParams();

  if (pageParam) {
    urlSearchParams.set('cursor', pageParam);
    urlSearchParams.set('limit', LIMIT.toString());
  }

  const { data } = await get<SessionsPageResponse>(`/v1.0/user/sessions?${urlSearchParams.toString()}`);
  return data;
};

const getNextPageParam = (lastPage: SessionsPageResponse) => {
  return lastPage.hasNextPage ? lastPage.nextCursor : undefined;
};

export const useAccountSessionsQuery = () => {
  return useInfiniteQuery({
    queryKey: ['userSessions'],
    queryFn: fetchUserSessions,
    enabled: true,
    initialPageParam: null as string | null,
    getNextPageParam,
  });
};

export default useAccountSessionsQuery;
